import { Fragment, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popover, Transition } from '@headlessui/react';
import { BarsArrowDownIcon, TrashIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';

import { ModalDeletePost } from './ModalDeletePost';
import { deletePost } from '../../../../redux/actions/home';

export const PostMenu = ({ postId, userId }) => {
    const dispatch = useDispatch();
    const [openModalDeletePost, setOpenModalDeletePost] = useState(false);
    const [loadingDeletePost, setLoadingDeletePost] = useState(false);
    const cancelDeletePost = useRef(null);

    const handleConfirmDeletePost = () => {
        setLoadingDeletePost(true);
        dispatch(deletePost(postId, userId))
            .then((result) => {
                if (result.status === 200) {
                    toast.success(result.message);
                    setOpenModalDeletePost(false);
                    setLoadingDeletePost(false);
                } else {
                    toast.error(result.message);
                    setOpenModalDeletePost(false);
                    setLoadingDeletePost(false);
                }
            });
    }

    return (
        <>
            <Popover className="relative">
                {({ open }) => (
                    <>
                        <Popover.Button
                            className='text-gray-950'
                        >
                            <BarsArrowDownIcon className='w-[16px]' />
                        </Popover.Button>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                        >
                            <Popover.Panel className="absolute z-10 -translate-x-[90%] transform w-[200px]">
                                <div className="overflow-hidden rounded-lg shadow-md shadow-indigo-900/10 ring-1 ring-black/5">
                                    <div className="relative flex flex-wrap gap-4 bg-white p-2">
                                        <button
                                            onClick={() => setOpenModalDeletePost(true)}
                                            className='w-full flex justify-around items-center p-2 rounded-md hover:bg-gray-100'>
                                            <TrashIcon className='w-[16px]' />
                                            <p>Borrar publicacion</p>
                                        </button>
                                    </div>
                                </div>
                            </Popover.Panel>
                        </Transition>
                    </>
                )}
            </Popover>
            <ModalDeletePost
                open={openModalDeletePost}
                setOpen={setOpenModalDeletePost}
                cancelButtonRef={cancelDeletePost}
                confirmAction={handleConfirmDeletePost}
                loadingDeleteMessage={loadingDeletePost}
                title={'Estas seguro de borrar la publicacion?'}
                labelButonConfirm={'Borrar publicacion'}
            />
        </>
    )
}